import { Component, inject, input, output } from '@angular/core';

import { ButtonV3Component } from 'components/atoms/button-v3/button-v3.component';
import type { IButtonStyleProperties } from 'components/atoms/button-v3/entities/types';
import { ImageComponent } from 'components/atoms/image/image.component';
import { AbstractWebsiteComponent } from 'components/molecules/abstract-website-component/abstract-website-component';
import type { ModalControl } from 'components/organisms/modal';
import { MODAL_CONTROL } from 'components/organisms/modal';
import { ButtonV3Service } from 'src/services/button/button-v3.service';

import { imageConfig } from './entities/const';
import type { IDialogContextData, IDialogStrings, TDialogButtonsIdentifiers } from './entities/types';

@Component({
    selector: 'website-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    imports: [ButtonV3Component, ImageComponent],
})
export class DialogComponent extends AbstractWebsiteComponent {
    readonly modalControl = inject<ModalControl<IDialogContextData>>(MODAL_CONTROL, { optional: true });
    private readonly buttonV3Service = inject(ButtonV3Service);

    private readonly ctx = this.modalControl?.contextData;

    public readonly dialogTestId = input<string | undefined>(this.ctx?.dialogTestId);
    public readonly strings = input<IDialogStrings>(this.ctx?.strings);
    public readonly isSecondaryButtonHidden = input(this.ctx?.isSecondaryButtonHidden ?? false);
    public readonly receiveAnswer = output<TDialogButtonsIdentifiers>();

    public readonly COMPONENT_NAME = 'website-dialog' + (this.ctx?.dialogTestId ? `-${this.ctx.dialogTestId}` : '');

    public readonly buttonStyleProperties: IButtonStyleProperties =
        this.buttonV3Service.getCallToActionButtonStyleProperties(
            { size: 'small', priority: 'tertiary', isShinyAnimatedButton: false },
            'white'
        );
    public readonly secondaryButtonStyleProperties: IButtonStyleProperties =
        this.buttonV3Service.getCallToActionButtonStyleProperties(
            { size: 'small', priority: 'primary', isShinyAnimatedButton: false },
            'white'
        );
    public readonly defaultImage = 'tp/static/assets/img/vector/icon-evo--user-key.svg';
    public readonly imageConfig = imageConfig;

    public handleAnswer(buttonIdentifier: TDialogButtonsIdentifiers): void {
        if (this.modalControl && !this.isHandleInVideoPopup()) {
            this.modalControl.close(buttonIdentifier);
        }

        this.receiveAnswer.emit(buttonIdentifier);
    }

    public handleClose(): void {
        this.modalControl?.close();
    }

    private isHandleInVideoPopup(): boolean {
        return this.modalControl
            ? !!('wistiaId' in this.modalControl.contextData && this.modalControl.contextData.wistiaId)
            : false;
    }
}
